<template>
<div>
    <!-- 头部导航start -->
    <div class="header_box">
      <div class="header over">
        <div>
          <a href="http://www.fangchan.com/" target="_Blank"><img  height="30" src="http://src.leju.com/imp/imp/deal/73/cf/a/6061a0a54769b6a5543b0f6da72_p24_mk24.png"></a>
        </div>
        <ul class="display" v-html="htmlArr[19].content"></ul>
      </div>		
    </div>
    <!-- 头部导航end -->
    <div class="magauto ediv3">
		<p class="ep1">频道正在升级中……</p>
		<p class="ep2">您还可以</p>
		<form action="http://credit.fangchan.com/searchList.html" method="GET">
			<div class="search-box1">
				<ul class="searchway1 clearfix">
                	<li class="activeway" id="xyxx" name="qymc">查企业</li>
                	<li id="xydm" name="tyshxym" class=""><a href="http://www.fangchan.com/">看新闻</a></li>
            	</ul>
            	<div class="searchbox">
                	<input v-model="qname" class="searchtext1" type="text" name="qymc" id="search_input" value="">
               		<div class="searchbtn1" id="searchbtn" @click="searchQy">搜索</div>
            	</div>	
			</div>
		</form>
		<div class="ebtn over">
			<a class="floatl ea2" href="http://credit.fangchan.com">行业信用</a>
			<a class="floatl ea2" href="http://credit.fangchan.com/pubinfo.html">舆情监督</a>
			<a class="floatl ea2 mag00" href="http://credit.fangchan.com/xinyongyanjiu.html">信用研究</a>
			<a class="floatl ea2" href="http://www.fangchan.com/news/">新闻资讯</a>
			<a class="floatl ea2" href="http://www.fangchan.com/data/">数据报告</a>
			<a class="floatl ea2 mag00" href="http://www.fangchan.com/policy/">政策法规</a>
		</div>





	</div>
</div>
</template>
<script>

function getData(thisObj, queryObj, countPerPage, currentPage, idArr){
  var paramsObj = {   
        params : {
              where: queryObj, 
              countPerPage: countPerPage, 
              currentPage: currentPage,
              idArr: (queryObj.qname == '') ? thisObj.awardSubId : idArr
        }
      };
  thisObj.$http.get('api/search/getcompany', paramsObj).then(
    response => {
        thisObj.tableData = response.body.listArr;
        thisObj.total = response.body.count;
      },
    response => {
        console.log('failed');
    }
  );
};
export default{
  name: 'index',
  data () {
      return {
          title: '行业测评频道',
          msg: '',
          tableData: [],  //按企业搜索结果
          anameOptions: [],  //一级奖项列表
          selectedOptions:[],
          subnameOptions: [],  //二级奖项列表
          qnameList:[],   //企业名称列表
          awardId: 1,
          awardSubId: '',
          awardsSubNames: '',
          awardsNames: '',
          loading: false,
          total:0,
          countPerPage: 10,
          currentPage: 1,
          year:'',
          formInline: {
            // awardId: '',
            qname: '',
            year: ''
          },
          idArr:[],
          firstIdArr:[],
          props: {
            value: 'value',
            label: 'label',
            children: 'children'
          },
          qname: '',
          isCur01: false,
          isCur02: false,
          isCur03: false,
          htmlArr:[]
      }
  },
  mounted: function(){
    var y = new Date();
    var year = y.getFullYear();
    this.year = year;
    this.$nextTick(function () {
          // 请求首页其他内容
           this.$http.get('/api/indexapi/getindex').then(
            response => {
              this.htmlArr = response.data.data;
              setTimeout(() => {
                const content0 = this.htmlArr[0].content;
                var i = 0;
                for(let v in content0){
                  i = i+1;
                  const color = content0[v].color;
                  if(color != ''){
                    $('.car-bg:nth-child('+ i +')').css({'background':color});
                  }
                }
                
              }, 1000)
            }
          )

          this.$http.get('/api/search/get_awards_sublist',{params: {preId: 1, year: year}}).then(  //获取500强子榜单的榜单列表
            response => {
              var sublist = response.body;
              this.subnameOptions = sublist.map(item => {
                if(item.issub == 0){
                  return {label: item.name, value: item.id};
                }else{
                  return {label: item.name, value: item.id, children:[]};
                }
              });
            }
          )
          
          var query = {awardId: 1, qname: ''};
          var paramsObj = {
            params : {
              where : query,
              countPerPage: this.countPerPage, 
              currentPage: this.currentPage,
            }
          };
          this.$http.get('api/search/getcompany', paramsObj).then(  //获取榜单列表
            response => {
                this.tableData = response.body.listArr;
                this.total = response.body.count;
              },
            response => {
              console.log('failed');
            }
          );
    });
  },
  methods: {
    getSubListData(val){
      this.tableData = []; 
      this.currentPage = 1;
      var awardId;
      if(val.length == 0){
        awardId = 1;
      }else{
        awardId = val[val.length - 1];
      }
      this.awardId = awardId;
      var query = {awardId: awardId, qname: '', year: this.formInline.year};
      var paramsObj = {
        params : {
          where : query,
          countPerPage: this.countPerPage, 
          currentPage: this.currentPage,
        }
      };
      this.$http.get('api/search/getcompany', paramsObj).then(
        response => {
            this.tableData = response.body.listArr;
            this.total = response.body.count;
          },
        response => {
          console.log('failed');
        }
      );

    },
    showData(val, b){
      if(b == 'cur01'){
        this.isCur01 = true;
        this.isCur02 = false;
        this.isCur03 = false;
      }else if(b == 'cur02'){
        this.isCur01 = false;
        this.isCur02 = true;
        this.isCur03 = false;
      }else if(b == 'cur03'){
        this.isCur01 = false;
        this.isCur02 = false;
        this.isCur03 = true;
      }else{
        this.isCur01 = false;
        this.isCur02 = false;
        this.isCur03 = false;
      }
      this.formInline.year = val;
      this.formInline.qname = '';
      this.selectedOptions = [];
      this.currentPage = 1;

      this.$http.get('/api/search/get_awards_sublist',{params: {preId: 1, year: val}}).then(  //获取500强子榜单的榜单列表
          response => {
            var sublist = response.body;
            this.subnameOptions = sublist.map(item => {
              if(item.issub == 0){
                return {label: item.name, value: item.id};
              }else{
                return {label: item.name, value: item.id, children:[]};
              }
            });
          }
        )


      var query = {awardId: 1, qname: '', year: val};
      var paramsObj = {
        params : {
          where : query,
          countPerPage: this.countPerPage, 
          currentPage: this.currentPage,
        }
      };

      this.$http.get('api/search/getcompany', paramsObj).then(
        response => {
            this.tableData = response.body.listArr;
            this.total = response.body.count;
          },
        response => {
          console.log('failed');
        }
      );
    },
    hasValue(strKey,arrObj){  //用于表格里某一列是否显示的判断： 该键值里的值如果有值，isvalue = true，否则 isvalue = false
      var hasvalue = false;
      for(var v in arrObj){
        if((arrObj[v][strKey] != '') && (arrObj[v][strKey] != 'undefined') && (arrObj[v][strKey] != null)){
          hasvalue = true;
        }else{
          hasvalue = false;
        }
      }
      return hasvalue;
    },
    onSubmit (val) {
      console.log(this.awardId);
      this.formInline.awardId = this.awardId;
      this.formInline.year = this.year;
      var url = '/#/search/result?qname='+ this.formInline.qname;
      window.open(url);
    },
    handleCurrentChange(val) { //当前在第几页
      this.formInline.year = this.year;
      this.formInline.awardId = this.awardId;
      this.currentPage = val;
      var query = {awardId: this.formInline.awardId, qname: '', year: this.formInline.year};
      var paramsObj = {
        params : {
          where : query,
          countPerPage: this.countPerPage, 
          currentPage: this.currentPage,
        }
      };
      this.$http.get('api/search/getcompany', paramsObj).then(
        response => {
            this.tableData = response.body.listArr;
            this.total = response.body.count;
          },
        response => {
          console.log('failed');
        }
      );
    },
    handleSizeChange(val) {  //每页显示多少条
      this.countPerPage = val;
      this.$router.push({path: 'result', query: this.formInline});
      getData(this, this.formInline, this.countPerPage, this.currentPage, this.idArr);
    },
    showCompany(v1,v2){ //企业展示
      console.log(v1,v2);
    },
    searchQy(){
      var url = 'http://credit.fangchan.com/searchList.html?qymc='+ this.qname;
      window.open(url);
    }
  }
}
</script>
<style src="../assets/index/css/mystyle.css"></style>
<style src="../assets/index/css/404.css"></style>
<style scoped>
/* .car-bg:nth-child(1){}
.car-bg:nth-child(2){background-color:#663f21;} */


</style>



// WEBPACK FOOTER //
// src/components/Index.vue